import React from 'react'
import styles from "./About.module.css"
import Container from '@material-ui/core/Container';
import { Box } from '@material-ui/core';
import { developerImage } from "../Data/Techlogo"

const About = () => {
    return (
        <div id="about" maxWidth="xl" className={styles.home}>
            <Box className={styles.mainBox}>
                {/* <Box className={styles.leftBox}> */}
                    <Box className={styles.infoBox}>
                        <h1>About Me</h1>
                        <span>
                            Hello, I'm Abhishek Chauhan, a Frontend Software Engineer with 2 years of experience. My expertise lies in product integration, resolving various bugs, tackling VQA problems & worked closely with desiner to fulfill the UI requirements, and ensuring comprehensive coverages. Passionate to work on frontend side, love to accept the challenge comes on the way.
                            Originally from Bokaro Steel City, Jharkhand, I earned my Bachelor's degree in Mechanical Engineering from Swami Vivekananda Institute of Science and Technology."
                        </span>
                    </Box>
                {/* </Box> */}
                <img src={developerImage} alt="developerImage"/>
            </Box>
        </div>
    )
}

export {About}
